<template>
  <div class="g-container-p">
    <div class="m-container-p">
      <!-- 面包屑 -->
      <div>
        <h3 style="margin-bottom: 0.6%;">
          <slot name="title"></slot>
        </h3>
        <h4>1.原材料储存:</h4>
        <div class="demo-image">
          <div class="block"
               v-for="(url,index) of rowPicDataArr"
               :key="index">
            <el-image style="width: 200px; height: 200px"
                      :src="url"
                      :fit="'scale-down'"
                      :preview-src-list="rowPicDataArr"></el-image>
          </div>
        </div>
        <slot name="radioInfo"></slot>
        <template>
          <div v-show="rawMaterialCheckFlag">
            <h4 style="margin-top: 20px;">2.原材料抽检：</h4>
            <div class="demo-image">
              <div class="block"
                   v-for="(url,index) of rowCheckPicDataArr"
                   :key="index">
                <el-image style="width: 200px; height: 200px"
                          :src="url"
                          :fit="'scale-down'"
                          :preview-src-list="rowCheckPicDataArr"></el-image>
              </div>
            </div>
            <slot name="checkInfo"></slot>
            <div v-if="getPDFShow">
              <el-link :href="oldRowCheckFile"
                       target="_blank"
                       type="primary">检测报告</el-link>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import "../../../../../html/pages/originality/createTestReport/createTestReport.scss"

import imageUpload from "../../../../../components/imageUpload/qeImageUpload"

export default {
  name: 'rawMaterialEnter',
  props: ['oldRowPicDataArr', 'oldRowCheckPicDataArr', 'oldRowCheckFile', 'rawCheckFlag'],
  watch: {
    oldRowPicDataArr (newValue) {
      this.rowPicDataArr = newValue;
      //console.log("oldRowPicDataArr", this.rowPicDataArr)
    },
    oldRowCheckPicDataArr (newValue) {
      this.rowCheckPicDataArr = newValue;
      //console.log("oldRowCheckPicDataArr", this.rowCheckPicDataArr)
    },
    rawCheckFlag (newValue) {
      this.rawMaterialCheckFlag = newValue;
      //console.log("rawCheckFlag", newValue)
    },
  },
  data () {
    return {
      rowPicDataArr: this.oldRowPicDataArr,//原材料存储原图
      rowCheckPicDataArr: this.oldRowCheckPicDataArr,//原材料抽检原图
      rawMaterialCheckFlag: this.rawCheckFlag,
      titleText: "",
      type: "",
    }
  },
  components: {
    imageUpload
  },
  computed: {
    getPDFShow () {
      if (this.oldRowCheckFile && this.oldRowCheckFile.trim() !== '') {
        return true
      }
      return false
    },
  },
  methods: {
    async uploadReprot (fn) {

    },
    init () {
      this.type = this.$route.query.type
    },
    created () {
      this.init()
    },
    beforeRouteUpdate (to, from, next) {
      next();
      this.init();
      this.picDataArr = []
    },
    reload () {
      this.uploadReprot(item => {
        window.location.reload()
      })
    },
  },
}
</script>

<style scoped>
.demo-image {
  width: 60%;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  justify-content: flex-start;
  align-items: flex-start;
}

.block {
  flex: 0 0 auto;
}
</style>
